import { useEffect, useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/category", label: "影视分类" },
  { to: "/search", label: "搜索" },
  { to: "/about", label: "关于我们" },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const term = keyword.trim();
    if (!term) return;
    navigate(`/search?q=${encodeURIComponent(term)}`);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/60"
          : "bg-gradient-to-b from-background-50/90 to-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-16 md:h-[72px] px-4 md:px-10">
        <Link to="/" className="flex items-center gap-2 shrink-0 group">
          <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
            <i className="ri-fire-fill text-lg" />
          </span>
          <span className="font-heading font-bold text-lg md:text-xl text-foreground-50 tracking-wide whitespace-nowrap">
            热情的邻居
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => {
            const active =
              item.to === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-2 text-sm rounded-md whitespace-nowrap transition-colors ${
                  active
                    ? "text-accent-500 bg-background-100"
                    : "text-foreground-300 hover:text-foreground-50 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <form
          onSubmit={handleSearch}
          className="hidden md:flex items-center gap-2 bg-background-100 border border-background-200/70 rounded-full px-4 h-10 w-56 lg:w-72"
        >
          <i className="ri-search-line text-foreground-500 text-sm" />
          <input
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="搜索影视、导演、演员"
            className="bg-transparent outline-none text-sm text-foreground-100 placeholder:text-foreground-600 w-full"
          />
          <button
            type="submit"
            className="text-xs text-primary-400 hover:text-primary-300 whitespace-nowrap cursor-pointer"
          >
            搜索
          </button>
        </form>

        <Link
          to="/search"
          aria-label="搜索"
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full text-foreground-100 hover:bg-background-100"
        >
          <i className="ri-search-line text-xl" />
        </Link>
      </div>
    </header>
  );
}